var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_Section_PageHeader',[_c('Help_Section',{attrs:{"info-text":_vm.$t('rankings.help-section')}}),_c('Header_Large',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.$t("rankings.title")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }